/**
 * Resolve the Adyen checkout API base URL from the environment string.
 */
export function getAdyenLoadingContext(environment) {
  const env = (environment || "test").toLowerCase();
  if (env === "test" || env === "local") {
    return "https://checkoutshopper-test.adyen.com/checkoutshopper/";
  }
  return `https://checkoutshopper-${env}.adyen.com/checkoutshopper/`;
}

/**
 * Adyen validates Apple Pay against window.location.hostname by default. In a
 * cross-origin iframe that is the Payweb host, while WebKit associates the
 * payment session with the top-level shop. Use the parent referrer so the
 * merchant session is issued for the domain that opened Apple Pay.
 */
export function buildIframeApplePayMerchantValidation({
  isInIframe,
  clientKey,
  environment,
  applePayConfig,
  referrer,
  fetchImpl,
  decodeBase64,
}) {
  if (!isInIframe) return undefined;

  return async (resolve, reject) => {
    try {
      const parentReferrer = referrer ?? document.referrer;
      const parentDomain = new URL(parentReferrer).hostname;
      const request = fetchImpl ?? fetch;
      const decode = decodeBase64 ?? atob;
      const loadingContext = getAdyenLoadingContext(environment);
      const url = `${loadingContext}v1/applePay/sessions?clientKey=${clientKey}`;
      const response = await request(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          displayName: applePayConfig?.merchantName || "Ontik Payment",
          domainName: parentDomain,
          initiative: "web",
          merchantIdentifier: applePayConfig?.merchantId,
        }),
      });

      if (!response.ok) {
        const responseText = await response.text();
        console.error(
          "[ontik] Apple Pay session request failed:",
          response.status,
          responseText,
        );
        reject("Could not get Apple Pay session");
        return;
      }

      const json = await response.json();
      resolve(JSON.parse(decode(json.data)));
    } catch (error) {
      console.error("[ontik] Apple Pay merchant validation error:", error);
      reject("Could not get Apple Pay session");
    }
  };
}
